import Number1 from './images/1.svg';
import Number2 from './images/2.svg';
import Number3 from './images/3.svg';
import Number4 from './images/4.svg';
import Number5 from './images/5.svg';
import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';

export function userTutorialDetailTexts(key: UserTutorialCompletionKey) {
    switch (key) {
        case UserTutorialCompletionKey.KEY_FIRST_LOGIN:
            return {
                image: Number1,
                number: 1,
                title: '初めてのログイン',
                description: '',
                comment: '',
            };
        case UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE:
            return {
                image: Number2,
                number: 2,
                title: 'SHElikesの使い方動画をみてみよう！',
                description:
                    'はじめてのログインが完了したら、SHElikesの使い方動画を視聴してみましょう！\nこのSHElikesの使い方動画では、SHElikesの活用方法を学ぶことができます。',
                comment: 'いよいよSHELifeのはじまりです',
            };
        case UserTutorialCompletionKey.KEY_JOIN_SLACK:
            return {
                image: Number3,
                number: 3,
                title: 'Slackに登録しよう！',
                description:
                    'SHElikesの使い方動画をみながら、SHElikesのSlackに登録してみましょう！\n登録用のURLは入会完了時のメールをご確認ください。',
                comment: 'Slackに登録できたら＃02_はじめての方へチャンネルをみてみよう♪',
            };
        case UserTutorialCompletionKey.KEY_RESERVE_COACHING:
            return {
                image: Number4,
                number: 4,
                title: '初回コーチングSTEP1を予約しよう！',
                description:
                    '受講開始日以降の日程から、初回コーチングSTEP1を予約しよう！\n初回コーチングSTEP1では、一緒に学び始める仲間と共に、理想の未来を描き、その未来に到達するための学習計画を立てます。\n予約方法は、「SHElikesの使い方動画」のコーチング編をご覧ください。\n受講開始日以降はコーチング参加有無に限らず、いつでもコースを受講いただけます。',
                comment: '初回コーチングSTEP1当日までに事前準備をしよう♪\n事前準備の方法は予約完了メールをみてねー！',
            };
        case UserTutorialCompletionKey.KEY_START_COURSE:
            return {
                image: Number5,
                number: 5,
                title: 'コースを1つ受講してみよう！',
                description:
                    'コース一覧から好きなコースを選択して受講を開始しましょう！\n動画はスマホでもPCでも視聴することができます。\n電車内やお風呂の中など、隙間時間をうまく活用していきましょう。\nおすすめの受講コースは「SHElikesの使い方動画」の「動画を受講してみよう」編をご覧ください。',
                comment: 'お気に入りのコースは見つかりましたか？\nこれから一緒に頑張りましょう！',
            };
        default:
            return {
                image: Number1,
                number: 1,
                title: '',
                description: '',
                comment: '',
            };
    }
}
